import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeAnalytics, trackPageView } from './firebaseAnalytics';

export default function AnalyticsRouteTracker(){
  const location = useLocation();
  const hasTrackedInitialRoute = useRef(false);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    if(!hasTrackedInitialRoute.current){
      hasTrackedInitialRoute.current = true;
      initializeAnalytics();
      return;
    }

    trackPageView(pagePath);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
